import React, { useEffect, useState } from "react";
import CommonGrid from "../../../../components/CommonGrid";
import urls from "../../../../Utils/urls";
import AttachmentsTab from "../../../LoanDetails/AttachmentsTab";
import axios from "../../../../axios";
import { gridColumns_paymentActivity } from "../../../../Utils/TableColumnDefs";
import {
  BlurWrapperWithSpan,
  DollarConvert,
  SpinnerBlock,
} from "../../../../Utils/CustomComponent";
import { useSelector } from "react-redux";
import { useAbortController } from "../../../../hooks/useAbortController";
import classes from "../../Pages/ReportAndDocumentBorrower/reports.module.css";
import { loadingTypes } from "../../../../Utils/constant";

const LDBDetailTable = ({ isLargeDevice }) => {
  const { signal } = useAbortController();
  const accountId = useSelector((state) => state.account.lenderId);
  // const [paymentActivity, setPaymentActivity] = useState(null);
  // const [loanFunding, setLoanFunding] = useState(null);
  const [trustLedgerReserve, setTrustLedgerReserve] = useState([]);
  const [reserveLoading, setReserveLoading] = useState("loading");
  // const [attachments, setAttachments] = useState(null);
  // useEffect(() => {
  //   setPaymentActivity(null);
  //   const fetchData = async () => {
  //     const res = await axios.get(urls.borrower.getPaymentActivity(accountId), {
  //       signal,
  //     });
  //     let data = res?.data?.[0] || [];
  //     setPaymentActivity(data);
  //   };
  //   fetchData();
  //   // setLoanFunding(null);
  //   // const fetchLoanFundingData = async () => {
  //   //   const res = await axios.get(urls.borrower.getLoanFunding(accountId));
  //   //   let data = res?.data?.[0] || [];
  //   //   setLoanFunding(
  //   //     data.map((innerData) => ({
  //   //       ...innerData,
  //   //       lender_account: extractLenderAccountValue(innerData.lender_account),
  //   //     }))
  //   //   );
  //   // };
  //   // fetchLoanFundingData();
  // }, [accountId]);
  useEffect(() => {
    // setTrustLedgerReserve(null);
    const fetchData = async () => {
      const res = await axios.get(
        urls.borrower.getTrustLedgerReserve(accountId),
        { signal }
      );
      let data =
        res?.data?.[0].map((item) => ({
          ...item,
          // Payment: item.Payment?.includes("(")
          //   ? -[item?.Payment?.replace(/[\$\(\)]/g, "")]
          //   : item?.Payment,
        })) || [];
      data.reverse();
      setTrustLedgerReserve(data);
      setReserveLoading("fulfilled");
    };
    fetchData();
  }, [accountId]);
  return (
    <>
      {/* <PaymentActivityTable isLargeDevice={isLargeDevice} /> */}
      {/* <div
        style={
          {
            backgroundColor: "#fff",
            borderRadius: "8px",
            marginBottom: "20px",
          } + isLargeDevice
            ? { overflowY: "scroll" }
            : null
        }
      >
        {paymentActivity ? (
          <CommonGrid
            isDashboard={true}
            className={`payment-activity-table col-sm-12 ${
              !isLargeDevice ? classes.pastDue15 : ""
            }`}
            title={"Payment Activity"}
            gridColumns={gridColumns_paymentActivity}
            columnData={paymentActivity}
          />
        ) : (
          <SpinnerBlock />
        )}
      </div> */}
      {/* <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        {loanFunding ? (
          <CommonGrid
            isDashboard={true}
            className={"col-sm-12"}
            title={"Loan Funding"}
            gridColumns={gridColumns_loanFunding}
            columnData={loanFunding}
          />
        ) : (
          <SpinnerBlock />
        )}
      </div> */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        {trustLedgerReserve?.length > 0 && (
          <CommonGrid
            isDashboard={true}
            className={"col-sm-12"}
            title={"Trust Ledger Reserve"}
            gridColumns={[
              { field: "Date", title: "Date" },
              {
                field: "Reference",
                title: "Reference",
                Cell: ({ value }) => (
                  <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>
                ),
              },
              {
                field: "From Whom Received",
                title: "From Whom Received",
                Cell: ({ value }) => (
                  <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>
                ),
              },
              {
                field: "Memo",
                title: "Memo",
                Cell: ({ value }) => (
                  <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>
                ),
              },
              {
                field: "Payment",
                title: "Payment",
                Cell: (props) => <DollarConvert props={props} />,
              },
            ]}
            columnData={trustLedgerReserve}
            tableTotal={["Payment"]}
            status={reserveLoading}
          />
        )}
      </div>
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
        }}
      >
        <div className="col-12 rounded p-4 attachments-table-borrower">
          <AttachmentsTab />
        </div>
      </div>
    </>
  );
};
export default LDBDetailTable;

export const PaymentActivityTable = ({
  isLargeDevice,
  modal = "false",
  viewAllModal = true,
  accountIdFromSelect = null,
  title = "Payment Activity",
}) => {
  const { signal } = useAbortController();
  const accountId = useSelector((state) => state.account.lenderId);
  const [paymentActivity, setPaymentActivity] = useState([]);
  const [status, setStatus] = useState(loadingTypes.fulfilled);

  useEffect(() => {
    setPaymentActivity([]);
    const fetchData = async () => {
      setStatus(loadingTypes.loading);
      const res = await axios.get(
        urls.borrower.getPaymentActivity(accountIdFromSelect),
        {
          signal,
        }
      );
      let data = res?.data?.[0] || [];
      setPaymentActivity(data);
      setStatus(loadingTypes.fulfilled);
    };
    if (accountIdFromSelect) {
      fetchData();
    }
    // setLoanFunding(null);
    // const fetchLoanFundingData = async () => {
    //   const res = await axios.get(urls.borrower.getLoanFunding(accountId));
    //   let data = res?.data?.[0] || [];
    //   setLoanFunding(
    //     data.map((innerData) => ({
    //       ...innerData,
    //       lender_account: extractLenderAccountValue(innerData.lender_account),
    //     }))
    //   );
    // };
    // fetchLoanFundingData();
  }, [accountIdFromSelect]);

  return (
    <div
      style={
        {
          backgroundColor: "#fff",
          borderRadius: "8px",
          marginBottom: "20px",
        } + isLargeDevice
          ? { overflowY: "scroll" }
          : null
      }
    >
      {/* {paymentActivity ? ( */}
      <CommonGrid
        isDashboard={true}
        className={`payment-activity-table col-sm-12 ${
          !isLargeDevice ? classes.pastDue15 : ""
        } ${modal ? "overflow-visible" : ""}`}
        title={title}
        gridColumns={gridColumns_paymentActivity}
        columnData={paymentActivity}
        viewAllModal={viewAllModal}
        status={status}
      />
      {/* ) : (
        <SpinnerBlock />
      )} */}
    </div>
  );
};
